// extracted by mini-css-extract-plugin
export default {"logo":"IconWithRotation_logo__N3ITS","rotate":"IconWithRotation_rotate__I5teC"};